// extracted by mini-css-extract-plugin
module.exports = {"containerIcon":"hRpWX6Dx4r3Az4IQ5W6X8","checkoutV2":"a_EVOam_-Evgjc0A9MAoK","menu":"_1rMSWHLRq3jE0Rv3sDZPnk","title":"_1XdRvcxp83EKtHEynIUHZ5"};